import {
  getCaseClassification,
  isRental,
  type CaseClassificationInput,
} from "./case-label";
import { isHomeSale } from "./case-classification";

export interface CaseMaterialInput extends Partial<CaseClassificationInput> {
  isRental?: boolean;
}

export type SalesMaterialLabel =
  | "Bestil salgsmateriale"
  | "Bestil salgsopstilling"
  | "Hent salgsmateriale";

export function caseMaterialLabel(
  property: CaseMaterialInput,
  salesLabel: SalesMaterialLabel = "Bestil salgsmateriale",
): string {
  const classification = getCaseClassification({
    taxons: property.taxons ?? [],
    estateTaxons: property.estateTaxons ?? [],
    estateNamespace: property.estateNamespace ?? "",
  });
  const rental = isRental(classification)
    ? true
    : isHomeSale(classification)
      ? false
      : property.isRental === true;
  if (!rental) return salesLabel;
  return salesLabel === "Hent salgsmateriale"
    ? "Hent materiale"
    : "Bestil materiale";
}
